import { makeActionFactory } from './actionFactory';
import { Report } from 'types';

export type ActionType =
    'DESIGNER_SET_REPORT'
    | 'DESIGNER_SAVE_REQUEST'
    | 'DESIGNER_SAVE_SUCCESS'
    | 'DESIGNER_SAVE_FAILURE'
    | 'DESIGNER_CANCEL'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  DESIGNER_SET_REPORT action causes the app to load a report in the report designer state.
//  It is dispatched by the editReportSaga in response to an EDIT_REPORT message.
//  It is also called every time the report is updated inside the designer.
//
export interface DesignerSetReportAction {
    type: 'DESIGNER_SET_REPORT';
    payload: Report;
    meta: {
        isNew?: boolean; // Only appears when dispatched from the saga; absent when dispatched from the Report Designer
    };
}
export const designerSetReport = actionFactory.payloadMeta<DesignerSetReportAction, Report, { isNew?: boolean }>('DESIGNER_SET_REPORT');


//
//  DESIGNER_SAVE_REQUEST action notifies the app that we want to save the report
//
export interface DesignerSaveRequestAction {
    type: 'DESIGNER_SAVE_REQUEST';
}
export const reportSaveRequest = actionFactory.empty<DesignerSaveRequestAction>('DESIGNER_SAVE_REQUEST');


//
//  DESIGNER_SAVE_SUCCESS action notifies the app that we successfully saved the report
//
export interface DesignerSaveSuccessAction {
    type: 'DESIGNER_SAVE_SUCCESS';
}
export const reportSaveSuccess = actionFactory.empty<DesignerSaveSuccessAction>('DESIGNER_SAVE_SUCCESS');


//
//  DESIGNER_SAVE_FAILURE action notifies the app that we failed to save the report
//
export interface DesignerSaveFailureAction {
    type: 'DESIGNER_SAVE_FAILURE';
    payload: Error;
    error: true;
}
export const reportSaveFailure = actionFactory.error<DesignerSaveFailureAction>('DESIGNER_SAVE_FAILURE');


//
//  DESIGNER_CANCEL action notifies the app that the user wants to abdandon the designer
//
export interface DesignerCancelAction {
    type: 'DESIGNER_CANCEL';
}
export const designerCancel = actionFactory.empty<DesignerCancelAction>('DESIGNER_CANCEL');



// WEBPACK FOOTER //
// ./src/actions/designerActions.ts